export function parseAddressValue(address) {
  if (!address) return '';

  let value = address;

  if (typeof value === 'string' && value.startsWith('{')) {
    try {
      const parsed = JSON.parse(value);
      value = parsed.full || value;
    } catch {
      const fullMatch = value.match(/full:\s*'([^']+)'/);
      if (fullMatch) {
        value = fullMatch[1];
      }
    }
  }

  if (typeof value === 'object' && value !== null) {
    value = value.full || JSON.stringify(value);
  }

  return typeof value === 'string' ? value.trim() : '';
}

export function formatAddressSlug(address) {
  const parsed = parseAddressValue(address);
  if (!parsed) return 'Unknown_Address';

  return parsed
    .replace(/[<>:"/\\|?*]/g, '')
    .replace(/,\s*/g, '_')
    .replace(/\s+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '')
    .substring(0, 80) || 'Unknown_Address';
}

export function formatPdfDate(date = new Date()) {
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC'
  }).replace(/,/g, '').replace(/\s+/g, '_');
}

export function buildPdfFileName(prefix, address, date = new Date()) {
  return `${prefix}_${formatAddressSlug(address)}_${formatPdfDate(date)}.pdf`;
}

export function buildReportPdfFileName(report, date = new Date()) {
  const isPreWork = report?.reportType === 'Pre-Work Inspection'
    || (report?.tasks?.length > 0 && (!report?.lineItems || report.lineItems.length === 0));
  const prefix = isPreWork ? 'PreWork_Inspection' : 'Inspection_Report';
  const address = report?.propertyAddress || report?.customerAddress;
  return buildPdfFileName(prefix, address, date);
}

export function getFilenameFromDisposition(response, fallbackName) {
  const disposition = response.headers?.get
    ? response.headers.get('content-disposition')
    : response.headers?.['content-disposition'];

  if (!disposition) return fallbackName;

  const match = disposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)"?/i);
  if (!match?.[1]) return fallbackName;

  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
}

export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export function downloadAxiosPdfResponse(response, fallbackName) {
  downloadBlob(new Blob([response.data]), getFilenameFromDisposition(response, fallbackName));
}

export async function downloadFetchPdfResponse(response, fallbackName) {
  const blob = await response.blob();
  downloadBlob(blob, getFilenameFromDisposition(response, fallbackName));
}
